'use client';

import { c as _c } from "react/compiler-runtime";
import { GoogleTagManager } from '@next/third-parties/google';
import { Theme } from '@nordcom/commerce-marketing-common';
import { NordstarProvider } from '@nordcom/nordstar';
import NextTopLoader from 'nextjs-toploader';
import * as NProgress from 'nprogress';
import type { ReactNode } from 'react';
import { Suspense, useEffect } from 'react';
import { Toaster } from 'sonner';
import { AdminBuildNotifier } from '@/components/build-notifier/build-notifier';
import { ClerkConvexProvider } from '@/components/providers/clerk-convex-provider';
export type ProvidersProps = {
  children: ReactNode;
};
/**
 * Root client provider tree for the admin shell.
 *
 * Mounts NordstarProvider, the Clerk-aware Convex client bridge, NextTopLoader, Toaster, Google Tag
 * Manager, and AdminBuildNotifier. The surrounding `<ClerkProvider>` lives in the server layout; this
 * tree consumes its session through {@link ClerkConvexProvider}.
 *
 * @param props.children - Application tree wrapped by all providers.
 */
export function Providers(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NextTopLoader color={Theme.accents.primary} showSpinner={true} crawl={true} />;
    t3 = <Toaster theme="dark" />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <GoogleTagManager gtmId="GTM-N6TLG8MX" />;
    t5 = <AdminBuildNotifier />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children) {
    t6 = <NordstarProvider theme={Theme}><ClerkConvexProvider><div><Suspense fallback={null}>{t2}{t3}{children}{t4}{t5}</Suspense></div></ClerkConvexProvider></NordstarProvider>;
    $[5] = children;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp() {
  NProgress.done();
}